import { Routes, Route } from "react-router-dom";
import AuditLogPage from "./AuditLogPage";

export default function AuditRoutes() {
  return (
    <Routes>
      <Route index element={<AuditLogPage />} />
    </Routes>
  );
}
